module.exports = {"planning":{"tour":{"permission":{"name":"operation.tour","actions":["visit"]},"link":"/operation/tour/tourSales","routeGlobal":"/operation/tour/","text":"menu.operation.tour","icon":"fal fa-suitcase-rolling","sub":[{"permission":{"name":"operation.tour","actions":["visit"]},"link":"/operation/tour/tourSales","text":"menu.operation.salesT"},{"permission":{"name":"operation.tour.sale","actions":["visit"]},"link":"/operation/tour/sales","text":"menu.operation.sales"}]}}}


//////////////////
// WEBPACK FOOTER
// ./src/components/app/user/partials/navbar/menu.json
// module id = HzcC
// module chunks = 8